import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router'

import { CompanyInfo, Invoice, MenuArrow, Order } from '../../Icons'
import {
  BottomBarDropDown,
  BottomBarDropDownItem,
  BottomBarDropDownIconContainer,
  BottomBarName
} from '../../../styles/defaults-header'

class CompanyMenu extends Component {
  handleClick(e) {
    this.props.onClickLink(e)
  }

  handleBack() {
    this.props.onClickBack()
  }

  render() {
    return (
      <BottomBarDropDown child z="1" right>
        <BottomBarName>Mijn bedrijf</BottomBarName>

        <BottomBarDropDownItem onClick={this.handleBack.bind(this)}>
          <BottomBarDropDownIconContainer black>
            <MenuArrow size="" />
          </BottomBarDropDownIconContainer>
          Terug
        </BottomBarDropDownItem>

        <Link to="/mijn-bedrijf/bedrijfsgegevens" onClick={this.handleClick.bind(this)}>
          <BottomBarDropDownItem>
            <BottomBarDropDownIconContainer>
              <CompanyInfo size="" />
            </BottomBarDropDownIconContainer>
            Bedrijfsgegevens
          </BottomBarDropDownItem>
        </Link>

        {this.props.permissions.viewOldOrders ? (
          <Link to="/mijn-bedrijf/orderhistorie" onClick={this.handleClick.bind(this)}>
            <BottomBarDropDownItem>
              <BottomBarDropDownIconContainer>
                <Order size="" />
              </BottomBarDropDownIconContainer>
              Orderhistorie
            </BottomBarDropDownItem>
          </Link>
        ) : null}

        {this.props.permissions.viewInvoices ? (
        <Link to="/mijn-bedrijf/facturen" onClick={this.handleClick.bind(this)}>
          <BottomBarDropDownItem>
            <BottomBarDropDownIconContainer>
              <Invoice size="" />
            </BottomBarDropDownIconContainer>
            Facturen
          </BottomBarDropDownItem>
        </Link>
        ) : null}

        {this.props.permissions.viewTech ? (
        <Link to="/mijn-bedrijf/technische-gegevens" onClick={this.handleClick.bind(this)}>
          <BottomBarDropDownItem>
            <BottomBarDropDownIconContainer>
              <Invoice size="" />
            </BottomBarDropDownIconContainer>
            Technische gegevens
          </BottomBarDropDownItem>
        </Link>
        ) : null}
      </BottomBarDropDown>
    )
  }
}

export default withRouter(CompanyMenu)



// WEBPACK FOOTER //
// ./src/components/MobileHeader/CompanyMenu/index.js